export const Acronyms = {
	GSD: {
		expanded: "Get Sh!t Done",
		acronym: "GSD"
	},
	IRL: {
		expanded: "in real life",
		acronym: "IRL"
	},
	 B: {
    expanded: " bajillion dollar",
    acronym: "B"
   },
   CEQA: {
   	expanded: "California Environmental Quality Act",
   	acronym: "CEQA"
   },
   LAUSD: {
   	expanded: "Los Angeles Unified School District",
   	acronym: "LAUSD"
   },
}

export const Citations = {
	"1": {
		link:'http://www.latimes.com/projects/la-pol-ca-california-governor-2018-money/',
		publication:"LA Times",
		headline: "With election day looming, donors pour millions into California governor’s race",
		directQuote:"Outside groups have pushed Antonio Villaraigosa into second place. Over a few days in April, four wealthy donors steered more than $12 million into a committee supporting Villaraigosa.",
	},
	"2": {
		link:'https://antonioforcalifornia.com/two-economies-op-ed/',
		publication:"Antonio's campaign website",
		headline: "California Has Two Economies, And One Isn't Progressing. Here's a Plan That Might Work",
		directQuote:"These new Prosperity Zones need the power to keep local funds local. They need the ability to adapt regulations to local realities while continuing to meet statewide goals. Most of all, they need the authority to act together as regional economies to help lift up every family in every part of California.",
	},
	"3": {
		link:'https://antonioforcalifornia.com/education-op-ed/',
		publication:"Antonio's campaign website",
		headline: "The California Students' Bill of Rights",
		directQuote:"New funding rules that require more equality in our schools are only a help if the money is spent on kids, not bureaucracy. We need to invest these new funds in better trained and better compensated teachers and other ways that impact the students who need the most help to succeed.",
	},
	"4": {
		link:'https://antonioforcalifornia.com/housing/',
		publication:"Antonio's campaign website",
		headline: "Building More Housing Will Build a Stronger Economy",
		directQuote:"These new Prosperity Zones need the power to keep local funds local. They need the ability to adapt regulations to local realities while continuing to meet statewide goals. Most of all, they need the authority to act together as regional economies to help lift up every family in every part of California.",
	},
	"5": {
		link:'https://www.scribd.com/document/131325807/Mayor-Villaraigosa-s-List-of-LAUSD-Education-Accomplishments-2005-2012',
		publication:"LA Mayor's Office",
		headline: "Mayor Villaraigosa’s List of LAUSD Education Accomplishments, 2005 – 2012",
		directQuote:"Founded by Mayor Villaraigosa in 2008, the Partnership for Los Angeles Schools is a collaboration betweenthe City of Los Angeles and LAUSD to turn around LA’s lowest performing schools. It is the largest publicschool turnaround project in the nation, serving nearly 16,000 students across 22 schools in the city’s poorest communities.",
	},
	"6": {
		link:'http://www.latimes.com/local/california/la-me-villaraigosa-legacy-20130629-dto-story.html',
		publication:"LA Times",
		headline: "Villaraigosa leaves a legacy of thinking big",
		directQuote:"But Villaraigosa made his own mark by leading the campaign for Measure R, a $35-billion transportation package passed by voters in 2008. Largely through that ballot measure, Villaraigosa reshaped the region's notoriously inefficient transit system more than any mayor since Bradley, who got a subway line built between downtown and North Hollywood.",
	},
}


// WEBPACK FOOTER //
// ./src/pages/june-5/races/data/governor/villaraigosa/expandables.js